import React from "react";

export const SectionTitle = ({ icon, tone, title, hint }) => (
  <div className="mr-sec-title">
    <span className={"mr-icon-tile mr-tone-" + tone}>{icon}</span>
    {title}
    {hint && <span className="mr-hint">{hint}</span>}
  </div>
);

export const Toggle = ({ on, onChange, title, hint, disabled = false, className = "" }) => (
  <button
    type="button"
    role="switch"
    aria-checked={on}
    disabled={disabled}
    className={"mr-toggle " + (on ? "mr-on " : "") + className}
    onClick={() => onChange(!on)}
  >
    <span className="mr-sw" />
    <span>
      <b>{title}</b>
      {hint && <small>{hint}</small>}
    </span>
  </button>
);

// Segmented control: options are [{ value, label, icon? }].
export const Segmented = ({ options, value, onChange, tone = "" }) => (
  <div className={"mr-seg" + (tone ? " mr-seg-" + tone : "")} role="radiogroup">
    {options.map((o) => (
      <button
        key={String(o.value)}
        type="button"
        role="radio"
        aria-checked={value === o.value}
        className={value === o.value ? "mr-on" : ""}
        onClick={() => onChange(o.value)}
      >
        {value === o.value && o.icon}
        {o.label}
      </button>
    ))}
  </div>
);

export const IconInput = ({ icon, error, children }) => (
  <div className={"mr-input" + (error ? " mr-err" : "")}>
    {icon}
    {children}
  </div>
);

// Shared react-select look for the report filters.
export const selectStyles = (hasError = false) => ({
  control: (base, state) => ({
    ...base,
    minHeight: 38,
    borderRadius: 9,
    borderWidth: 1.5,
    borderColor: hasError ? "#e11d48" : state.isFocused ? "#0d9488" : state.hasValue ? "#99f6e4" : "#cbd5e1",
    backgroundColor: hasError ? "#fff8f9" : state.hasValue ? "#f0fdfa" : "#fff",
    boxShadow: state.isFocused ? "0 0 0 3px rgba(13, 148, 136, 0.15)" : "none",
    "&:hover": { borderColor: state.isFocused ? "#0d9488" : "#94a3b8" },
  }),
  placeholder: (base) => ({ ...base, color: "#94a3b8" }),
  multiValue: (base) => ({ ...base, backgroundColor: "#ccfbf1", borderRadius: 7 }),
  multiValueLabel: (base) => ({ ...base, color: "#115e59" }),
  multiValueRemove: (base) => ({
    ...base,
    color: "#0f766e",
    borderRadius: 7,
    ":hover": { backgroundColor: "#99f6e4", color: "#134e4a" },
  }),
  menu: (base) => ({ ...base, zIndex: 20, borderRadius: 10, overflow: "hidden" }),
});
